import { useQuery } from '@tanstack/react-query'
import { getData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { parseQueryParams } from '../../utilities/parsers'

const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}

const fetchMaterials = async () => {
  const url = buildUrlWithParams(apiUrl.MATERIAL_LIST)
  const response = await getData(url)
  return response
}
export const useMaterialList = () => {
  return useQuery(['material_listing'], () => fetchMaterials(), {
    refetchOnWindowFocus: false,
  })
}
const fetchPhotos = async () => {
  const url = buildUrlWithParams(apiUrl.PHOTOS_LIST)
  const response = await getData(url)
  return response
}
export const usePhotosList = () => {
  return useQuery(['photos_listing'], () => fetchPhotos(), {
    refetchOnWindowFocus: false,
  })
}
